export const LOGIN_USER = "LOGIN_USER"
export const LOGOUT_USER = "LOGOUT_USER"
export const  CANCEL_PARTNERSHIP = "CANCEL_PARTNERSHIP"
export const  REGISTER_PARTNERSHIP = "REGISTER_PARTNERSHIP"
export const  DARK_MODE = "DARK_MODE"
export const  CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const  VERIFY = "VERIFY"
export const  REGISTER_USER = "REGISTER_USER"
